export default __webpack_public_path__ + "static/media/pearl-bg.831d79f7.jpg";